import { render, staticRenderFns } from "./DashboardApproval.vue?vue&type=template&id=27221fab&scoped=true&"
import script from "./DashboardApproval.vue?vue&type=script&lang=js&"
export * from "./DashboardApproval.vue?vue&type=script&lang=js&"
import style0 from "../InputPPM/DashboardPPCM.scss?vue&type=style&index=0&id=27221fab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27221fab",
  null
  
)

export default component.exports